export type AddCartItem = {
  entity_id: string;
  season?: number;
  quantity: number;
  state_id?: string;
  payment_amount?: number;
  from_date?: string | null;
  to_date?: string | null;
  accounting_method?: string;
  task_name?: string | null;
  quarter?: string;
  bundle?: boolean;
  deadline_date?: string;
  product_content_type_id: number;
  product_id: string;
  parent_template?: string;
  base_task_key?: string;
};

export type AddBulkCartItem = AddCartItem & {
  action: keyof typeof BULK_CART_ACTIONS | "";
};

export const BULK_CART_ACTIONS = {
  ADD_TO_CART: "ADD_TO_CART",
  SAVED_FOR_LATER: "SAVED_FOR_LATER",
  DELETE: "DELETE_FROM_CART",
} as const;

export const BULK_CART_ACTIONS_DISPLAY = {
  [BULK_CART_ACTIONS.ADD_TO_CART]: "Add to cart",
  [BULK_CART_ACTIONS.SAVED_FOR_LATER]: "Save for later",
  [BULK_CART_ACTIONS.DELETE]: "Delete from cart",
};
